module.exports = __webpack_public_path__ + "static/media/Map.d25e16e0.png";